// Affiliate collection
export const AFFILIATES_GET = 'AFFILIATES_GET';
export const AFFILIATES_GET_DETAILS = 'AFFILIATES_GET_DETAILS';

// Single affiliates
export const AFFILIATE_GET = 'AFFILIATE_GET';
export const AFFILIATE_GET_BY_SLUG = 'AFFILIATE_GET_BY_SLUG';
export const AFFILIATE_GET_BY_AFFILIATION_CODE = 'AFFILIATE_GET_BY_AFFILIATION_CODE';
export const AFFILIATE_GET_DETAILS = 'AFFILIATE_GET_DETAILS';
